import React from 'react';

export default function nl2br(text) {
  const splitByNewLine = text.split('\n');
  const lengthOfSplitByNewLine = splitByNewLine.length;

  return splitByNewLine.map((e, idx) => (<span key={idx}>{e}{ idx !== (lengthOfSplitByNewLine - 1) ? <br /> : null}</span>));
}



// WEBPACK FOOTER //
// ./src/utils/nl2br.js